import { render } from "./productFullReport.vue?vue&type=template&id=2a4769d6&scoped=true"
import script from "./productFullReport.vue?vue&type=script&lang=js"
export * from "./productFullReport.vue?vue&type=script&lang=js"

import "./productFullReport.vue?vue&type=style&index=0&id=2a4769d6&scoped=true&lang=css"
import "./productFullReport.vue?vue&type=style&index=1&id=2a4769d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4769d6"]])

export default __exports__